import { JsonObject } from 'type-fest';

export const aria: JsonObject = {
  decrease: 'Zmniejsz',
  increase: 'Zwiększ',
  rangeSlider: 'Suwak zakresu',
  delete: 'Usuń',
};
